export default __webpack_public_path__ + "static/media/checkmark_filled.389d5695.svg";